import Navbar from "@/components/local-route/Navbar";
import Hero from "@/components/local-route/Hero";
import Features from "@/components/local-route/Features";
import Pricing from "@/components/local-route/Pricing";
import ComparisonTable from "@/components/local-route/ComparisonTable";
import Testimonials from "@/components/local-route/Testimonials";
import BrowserDownload from "@/components/local-route/BrowserDownload";
import Install from "@/components/local-route/Install";
import FAQ from "@/components/local-route/FAQ";
import Footer from "@/components/local-route/Footer";
import StickyCTA from "@/components/local-route/StickyCTA";

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="flex-1">
        <Hero />
        <Features />
        <Pricing />
        <ComparisonTable />
        <Testimonials />
        <BrowserDownload />
        <Install />
        <FAQ />
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

export default Home;
